import React from "react"
import Select from "react-select"

const customStyles = {
  menu: (provided) => ({ ...provided, zIndex: 9999 }),
  control: (provided, state) => ({
    ...provided,
    backgroundColor: "#f8f9fa",
    borderColor: state.isFocused ? "#20b2aa" : "#dee2e6",
    boxShadow: state.isFocused ? "0 0 0 1px #20b2aa" : "none",
    minHeight: "2.8125rem",
    "&:hover": {
      borderColor: state.isFocused ? "#20b2aa" : "#dee2e6",
    },
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused
      ? "#20b2aa"
      : state.isSelected
      ? "#20b2aa"
      : "white",
    color: state.isFocused ? "white" : state.isSelected ? "white" : "black",
    "&:hover": {
      backgroundColor: "#20b2aa",
      color: "white",
    },
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "#495057cc",
  }),
  menuPortal: (provided) => ({
    ...provided,
    zIndex: 1060,
  }),
}

const CustomSelect = ({
  value,
  handleSelectChange = () => {},
  options,
  isMulti = false,
  placeholder,
  classNameSelect,
  isSearchable = true,
  ...props
}) => {
  return (
    <div>
      <Select
        menuPosition="fixed"
        {...props}
        isMulti={isMulti}
        value={value}
        onChange={(selectedOption) => {
          handleSelectChange(selectedOption)
        }}
        isSearchable={isSearchable}
        isClearable
        options={options}
        placeholder={placeholder || "Select"}
        styles={customStyles}
        className={classNameSelect}
      />
    </div>
  )
}

export default CustomSelect
